export default {
  list: ({ GET }, data) =>
    new Promise((resolve, reject) => {
      return GET(`production/commissions`, { ...data })
        .then((reponse) => {
          const data = reponse.data
          if (reponse.status === 200 && data) {
            resolve(data)
          } else {
            reject(reponse.status)
          }
        })
        .catch((error) => {
          reject(error)
        })
    }),
  listAgence: ({ GET }, data) =>
    new Promise((resolve, reject) => {
      return GET(`production/commissions/agence`, { ...data })
        .then((reponse) => {
          const data = reponse.data
          if (reponse.status === 200 && data) {
            resolve(data)
          } else {
            reject(reponse.status)
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
}
